var Model = require("../types/Model.js");
var xtend = require("xtend");

module.exports = Model({
	name: "groupmanagegroups",
	init,
	uninit,
	listeners,

	refresh,
	trackChanges
});

function init() {
	this._ready = false;
	this._orgGroup = null;
	this._group_tracker = this.dispatcher.createTracker();
	this.push([]);
}

function uninit() {
	let tracker = this._group_tracker;
	tracker.off;
	tracker = null;
}

function listeners() {
	return {
		"loadchecker:ready": initial_load,
		"connectivity:online": refresh,
		"orggroup:updated": handleOrgGroupUpdate
	};
}

function initial_load() {
	this._ready = true;
	this.refresh();
}

function refresh() {
	if(!this._ready) return Promise.resolve([]);
	return this.api.org.managergroups.list()
		.then(this.push.bind(this))
		.then(trackChanges.bind(this));
}

function trackChanges(){
	var groups = this.data;
	const tracker = this._group_tracker;
	const orgGroup = this._orgGroup;
	if(!orgGroup) return;

	tracker.off();
	tracker.on(`mqtt:orggroup/${orgGroup}/managegroup/created`, handle_created.bind(this));
	groups.forEach(group => {
		tracker.on(`mqtt:orggroup/${orgGroup}/managegroup/${group._id}/removed`, handle_removed.bind(this));
		tracker.on(`mqtt:orggroup/${orgGroup}/managegroup/${group._id}/updated`, handle_updated.bind(this));
	});
}

function handleOrgGroupUpdate(group){
	this._orgGroup = group;
	this.trackChanges();
}

function handle_created(group){
	let current = this.data;
	const newList = current.concat(group);
	this.push(newList);
}

function handle_removed(data){
	const remove = data.manageGroup;
	let current = this.data;
	const newList = current.filter(group => group._id !== remove);
	this.push(newList);
}

function handle_updated(data){
	const updateId = data.manageGroup;
	let current = this.data;
	const newList = current.map((group) => {
		if(group._id === updateId)
			return xtend(group, data);
		return group;
	});
	this.push(newList);
}

